import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import getShadeMap from '../modules/getShadeMap'

function Theme({
  selector,
  variable,
  color,
}) {
  if (!color || !variable || !selector) {
    // eslint-disable-next-line no-console
    console.warn(`Failed theme declaration: ${[
      !color && `color: ${color}`,
      !variable && `variable: ${variable}`,
      !selector && `selector: ${selector}`,
    ].filter(Boolean).join(', ')} in  '<Theme />'.`)
    return null
  }

  const theme = useMemo(() => {
    const colorMap = getShadeMap(color)
    return ` 
    ${selector} {
      ${colorMap.join(';\n')}
    }
  `
  }, [color])

  return (
    <style type="text/css">
      {theme}
    </style>
  )
}

Theme.propTypes = {
  selector: PropTypes.string,
  variable: PropTypes.string,
  color: PropTypes.string.isRequired,
}

Theme.defaultProps = {
  selector: ':root',
  variable: 'theme',
}

export default Theme
